import React from 'react';
import { PozadinskiPosao } from '../types';

/**
 * Pozadinski posao koji ne radi — traka na vrhu Terena.
 *
 * Analiza scenarija (K22), 16.10.2026: svih sedam pozadinskih poslova (uvoz
 * adresa, slanje poruka, zatvaranje rezervacija, kukičanje, GPS, javljanje
 * objektima, podsetnik za prijem) grešku je upisivalo samo u dnevnik servera.
 * Kad ERP ili baza ne odgovaraju satima, operater je video samo da „nema
 * posla".
 *
 * Traka gori tek posle tri pada zaredom: jedan pad je najčešće ERP koji se
 * trgnuo, a traka koja gori na svaki trzaj postaje tapet.
 */
export default function PozadinaUzbuna({ poslovi }: { poslovi: PozadinskiPosao[] }) {
  return (
    <>
      {poslovi.filter((p) => p.neRadi).map((p) => (
        <div className="health health--bad" key={p.posao}>
          <strong>Pozadinski posao ne radi — {p.posao}.</strong>{' '}
          Pao je {p.padovaZaredom} puta zaredom
          {p.poslednjiPad && <>, poslednji put {new Date(p.poslednjiPad).toLocaleString('sr-RS')}</>}.
          {p.poslednjiUspeh
            ? <> Poslednji put je prošao {new Date(p.poslednjiUspeh).toLocaleString('sr-RS')}.</>
            : <> Od pokretanja aplikacije nije prošao nijednom.</>}
          {p.greska && <> Greška: <code>{p.greska}</code>.</>}
          <br />
          Šta to znači: {p.posledica}. Posao pokušava sam ponovo; ako ovo traje, javi da se
          proveri server.
        </div>
      ))}
    </>
  );
}
